import { createContext, useContext} from 'react';

export const AuthContext = createContext(false);
export default function useAuthContext() {
    return useContext(AuthContext);
}
